import { normalizeTargetingParameter } from '../../utils/helpers/normalizeTargetingParameter';

const init = async (L, container_id, ar_cn, target={}) => {
  if (!process.browser || process.env.NODE_ENV !== `production`) return null;

  var custom = [];

  if (Object.entries(target).length) {
    custom[1] = target?.leased ? 'Kiraye' : 'Alis'
    custom[5] = target?.rooms
    custom[6] = normalizeTargetingParameter(target?.category?.name)
    custom[7] = target?.hasRepair ? 'true' : 'false'
    custom[8] = normalizeTargetingParameter(target?.city?.name)
    custom[9] = target?.price?.value
    custom[10] = target?.hasBillOfSale ? 'true' : 'false' 
    custom[11] = target?.hasMortgage ? 'true' : 'false'
  }

  // main logic
  custom.getStd = function(){for(var i=0,j,s=[];i<this.length;i++){if(this[i])s.push((!j?(j=1,i+'='):'')+escape(this[i]));else j=0}return s.length?'&custom='+s.join(';'):''};
  if (typeof ar_cn === "undefined" || ar_cn === "null") ar_cn = 1;
  var S = 'setTimeout(function(e){if(!self.CgiHref){document.close();e=parent.document.getElementById("ar_container_"+ar_bnum);e.parentNode.removeChild(e);}},3000);',
    j = ' type="text/javascript"', t = 0, D = document, n = ar_cn; L = '' + ('https:' == document.location.protocol ? 'https:' : 'http:') + '' + L + escape(D.referrer || 'unknown') + '&rnd=' + Math.round(Math.random() * 999999999)+custom.getStd();
  function _() {
    if (t++ < 100) {
      var F = D.getElementById('ar_container_' + n);
      if (F) {
        try {
          var d = F.contentDocument || (window.ActiveXObject && window.frames['ar_container_' + n].document);
          if (d) { d.write('<sc' + 'ript' + j + '>var ar_bnum=' + n + ';' + S + '<\/sc' + 'ript><sc' + 'ript' + j + ' src="' + L + `" onload="parent.adriverExtentionLoad(ar_adid,bid, '${container_id}')"><\/sc` + 'ript>'); t = 0;}
          else setTimeout(_, 100);
        } catch (e) {
          try {
            F.src = "javascript:{document.write('<sc'+'ript" + j + ">var ar_bnum=" + n + "; document.domain=\""
              + D.domain + "\";" + S + "<\/sc'+'ript>');document.write('<sc'+'ript" + j + " src=\"" + L + `" onload=\"parent.adriverExtentionLoad(ar_adid,bid, '${container_id}')\"><\/sc'+'ript>');}`; return
          } catch (E) { }
        }
      } else setTimeout(_, 100);
    }
  }
  if (!D.querySelector(`#${container_id}`)) return
  D.querySelector(`#${container_id}`).innerHTML = ('<div style="visibility:hidden;height:0px;left:-1000px;position:absolute;"><iframe title="Interactive content" id="ar_container_' + ar_cn
    + '" width=1 height=1 marginwidth=0 marginheight=0 scrolling=no frameborder=0><\/iframe><\/div><div id="ad_ph_' + ar_cn
    + '" style="display:none;"><\/div>'); _();
};

export default (container_id, sid, bn, arCn, target={}) => {
  const link = `//ad.adriver.ru/cgi-bin/erle.cgi?sid=${sid}&bn=${bn}&bt=43&pz=0&target=top&tail256=`;
  const initialize = async () => await init(link, container_id, arCn, target);
  initialize();
}
